import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import xlentLogo from '../assets/tlogo.jpg';
import { useAuth } from '../contexts/AuthContext';

export default function TopBar({ onMenuClick }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [loggingOut, setLoggingOut] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    setLoggingOut(true);
    await logout();
    setLoggingOut(false);
  };

  return (
    <header className="flex items-center justify-between px-2 sm:px-4 md:px-8 py-2 sm:py-3 md:py-4 bg-surface-50 shadow-sm sticky top-0 z-30">
      {/* Left: Hamburger for mobile */}
      <div className="flex items-center gap-2 sm:gap-4">
        {/* Hamburger menu for mobile */}
        <button
          className="md:hidden text-2xl px-2 py-1 focus:outline-none"
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <span className="block w-6 h-0.5 bg-gray-700 mb-1 rounded"></span>
          <span className="block w-6 h-0.5 bg-gray-700 mb-1 rounded"></span>
          <span className="block w-6 h-0.5 bg-gray-700 rounded"></span>
        </button>
        {/* Home button */}
        <button
          className="flex items-center gap-1 bg-surface-100 text-gray-800 text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-md font-semibold hover:bg-surface-200 focus:outline-none focus:ring-2 focus:ring-surface-300 transition"
          onClick={() => navigate('/')}
          aria-label="Home"
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l9-9 9 9M4 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10" />
          </svg>
          <span className="hidden xs:inline">Home</span>
        </button>
      </div>
      {/* Center/Right: Action buttons and User dropdown */}
      <div className="flex items-center gap-2 sm:gap-3 ml-2">
        {/* +Customer and +Order buttons */}
        <button
          className="bg-primary-600 text-white text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-sm font-semibold shadow hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-400 transition"
          onClick={() => navigate('/add-customer')}
        >
          + Customer
        </button>
        <button
          className="bg-primary-600 text-white text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-sm font-semibold shadow hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-400 transition"
          onClick={() => navigate('/create-order')}
        >
          + Order
        </button>
        {/* User dropdown */}
        <div className="relative" ref={dropdownRef}>
          <div
            className="flex items-center gap-2 cursor-pointer select-none px-2 py-1 rounded hover:bg-surface-100 transition"
            onClick={() => setDropdownOpen((open) => !open)}
          >
            <img src={xlentLogo} alt="TeenageFashion Logo" className="w-8 h-8 rounded-full object-cover" />
            <span className="text-secondary-700 font-medium text-sm hidden sm:inline">Hi, TeenageFashion</span>
            <svg className="w-4 h-4 text-secondary-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
          </div>
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-32 bg-surface-50 border border-surface-200 rounded shadow-lg z-40">
              <button
                className="block w-full text-left px-4 py-2 text-secondary-700 hover:bg-surface-100 disabled:opacity-50"
                onClick={handleLogout}
                disabled={loggingOut}
              >
                {loggingOut ? 'Logging out...' : 'Logout'}
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
